module.exports = __webpack_public_path__ + "static/media/no-reports.bd0c922e.svg";